import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./i18n/index";
import App from "./modules/App";
import { initializeApp } from "firebase/app";

const root = ReactDOM.createRoot(document.getElementById("root")!);
const firebaseConfig = {
  apiKey: "AIzaSyB-CUy9p5JpNZNAh-85p-OyDy9UKaixsDY",
  authDomain: "nl-internacional.firebaseapp.com",
  projectId: "nl-internacional",
  storageBucket: "nl-internacional.appspot.com",
  messagingSenderId: "1042089978468",
  appId: "1:1042089978468:web:ef927ded13a67f0b1c0d71",
  measurementId: "G-9N3JLTZ34K",
};

// Initialize Firebase
initializeApp(firebaseConfig);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
